import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, concatMap, delay } from 'rxjs/operators';
import * as importCatalog from '@webapp/sdk/import-catalog';
import { Actions } from '../../actions';
import {
  TrackImportProgress,
  TrackImportProgressSuccess,
  ImportCatalogSuccess,
  TrackImportProgressError,
} from '../action-creators';
import { TRACK_IMPORT_PROGRESS } from '../actions';

const MAX_RETRY = 10;

export const trackImportProgressEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, TrackImportProgress>(TRACK_IMPORT_PROGRESS),
    delay(2000),
    mergeMap(async (action) => {
      try {
        const response = await importCatalog.progress(action.artistId);
        if (
          response.total - (response.completed + response.failed) &&
          action.retry <= MAX_RETRY
        ) {
          return [
            new TrackImportProgressSuccess(
              action.artistId,
              (response.completed / response.total) * 100
            ),
            new TrackImportProgress(action.artistId, action.retry + 1),
          ];
        }
        return [new ImportCatalogSuccess(action.artistId)];
      } catch (err) {
        return [new TrackImportProgressError((err as Error).message)];
      }
    }),
    concatMap((actions) => actions)
  );
